<template>
  <scrollmenu :showArrows="this.reviews > 2 ? true : false">
    <slot />
  </scrollmenu>
</template>

<script>
import Scrollmenu from "@/components/Sidescroll/Scrollmenu.vue";

export default {
  name: "reviewcards",
  props: ['reviews'],
  components: {
    Scrollmenu
  }
};
</script>

<style scoped>
</style>